export const searchScrollParamsGenerator = index => ({
  index: index,
  align: 'start',
  behavior: 'smooth'
});